import type { ImageModel } from '@coas/db/model';
import type { ImageLoader } from 'next/image';
import { env } from '~/env';

import { type MakeImgLoaderArgs, createImgLoaderFactory, createProductImgLoaderFactory } from '@coas/image-loaders';

const BASE = env.NEXT_PUBLIC_SERVER_URL;

export const imgLoader = (args: MakeImgLoaderArgs): ImageLoader => createImgLoaderFactory(BASE, '/api/image')(args);

export const makeProductImgLoader = (image: ImageModel): ImageLoader =>
    createProductImgLoaderFactory(BASE, '/api/imageProduct')(image);

export const b64ToU8 = (b64: string): Uint8Array => {
    const bin = atob(b64);
    const u8 = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) u8[i] = bin.charCodeAt(i);
    return u8;
};
